export default class kvSlider {
  constructor(opt = {}) {
    this.media = opt.media;
  }
  init() {
    this.slickSlider();
    this.kvInsertBg();
  }

  slickSlider(){
    $('.p-top_kv_slider').slick({
      dots: true,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 5000,
      prevArrow:'<div class="slick-arrow_prev pc"></div>',
      nextArrow:'<div class="slick-arrow_next pc"></div>',
      centerMode:true,
      centerPadding: 0,
      responsive: [
      {
        breakpoint: 767,
        settings: {
         arrows:false,
          }
      }]
    });
  }

  kvInsertBg(){
    var $elm = $('.js-kv_insert_bg');
    const filename = this.media === 'pc'? '_pc' : '_sp';
    $elm.each(function() {
      var str = $(this).data('kv');
      var result = str.slice( 0, -7 ) ;
      $(this).css('background-image', 'url(' + result + filename + '.jpg)');
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/kv_slider.js